export const black              = '#000';
export const darkBlue           = '#001529';
export const fontColor          = '#000000A5';
export const lightFontColor     = '#00000040';
export const secondaryFontColor = '#1890FF';
export const borderColor        = '#000000A5';
export const white              = '#FFFFFF';
export const lightGrey          = '#D4D7D9';
export const red                = '#e1001a';
